export const mergeCartItemsPreservingOrder = <T extends { id: string }>(
	current: readonly T[],
	incoming: readonly T[],
): T[] => {
	if (current.length === 0) {
		return [...incoming];
	}
	const incomingById = new Map(incoming.map((item) => [item.id, item]));
	const seen = new Set<string>();
	const merged: T[] = [];
	for (const item of current) {
		const next = incomingById.get(item.id);
		if (next) {
			merged.push(next);
			seen.add(item.id);
		}
	}
	for (const item of incoming) {
		if (!seen.has(item.id)) {
			merged.push(item);
		}
	}
	return merged;
};
